import React from 'react'
import styles from './index.module.scss'

export default function Footer() {
  return (
    <div style={{ marginTop: 60, background: '#020e3e' }}>
      <div className={styles.footer} data-flex="cross:center" >
        <ul>
          <li className={styles.productTitle}>产品服务</li>
          <li>科研教育</li>
          <li>科研大数据</li>
          <li>科研服务</li>
        </ul>
        <ul>
          <li className={styles.productTitle}>创新产品</li>
          <li style={{ lineHeight: '22px' }}>呼吸疾病临床研究大数据平台</li>
          <li>中国队列共享平台</li>
        </ul>
        <ul>
          <li className={styles.productTitle}>关于我们</li>
          <li>公司简介</li>
          <li>加入我们</li>
        </ul>
        <ul style={{ marginRight: 0, width: 350 }}>
          <li className={styles.productTitle}>联系我们</li>
          <li>Tel：010-84148036</li>
          <li>Email：business@natureself.cn</li>
          <li>地址：北京市朝阳区望京科技创业园E座315A</li>
        </ul>
      </div>
      <div className={styles.copyright}>
        ©2022 北京泽创天成科技发展有限公司 版权所有京ICP备16045582号
      </div>
    </div>
  )
}
